import React from 'react';
import ReactDOM from 'react-dom';
import {Router, Route, Redirect, Switch} from 'react-router-dom';

import AppProviders from './components/AppProviders';
import ScrollToTop from './components/ScrollToTop';

import Page from './components/shared/page';
import history from './history';
import {
	privateRoutes,
	publicRoutes,
	publicRoutePaths,
	HOME_ROUTE,
} from './routes';

const App = () => {
	return (
		<Router history={history}>
			<AppProviders>
				<ScrollToTop />
				<Switch>
					<Route exact path={publicRoutePaths}>
						<Switch>
							{publicRoutes.map((routeProps, i) => (
								<Route key={i} {...routeProps} />
							))}
						</Switch>
					</Route>
					<Route>
						<Page>
							<Switch>
								{privateRoutes.map((routeProps, i) => (
									<Route key={i} {...routeProps} />
								))}
								<Redirect to={HOME_ROUTE} />
							</Switch>
						</Page>
					</Route>
				</Switch>
			</AppProviders>
		</Router>
	);
};

export default function () {
	ReactDOM.render(<App />, document.getElementById('root'));
}
